// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-dna-syngovia-empty-state',
  templateUrl: './dna-syngovia-empty-state.component.html',
  styleUrls: ['./dna-syngovia-empty-state.component.scss'],
})
export class DnaSyngoviaEmptyStateComponent {}
